import React, {useEffect, useState} from "react"
import {useOutletContext, useLocation, Outlet} from "react-router-dom"
import api, {requestFailed} from "../Scripts/api"
import PostCard from "../Components/PostCard"
import Loading from "../Components/Loading"

function Liked() {

    const oc = useOutletContext().oc
    const locarr = useLocation().pathname.split('/').filter((char) => char !== '')
    const location = locarr[locarr.length - 1]
    const [liked, setLiked] = useState()
    const [loading, setLoading] = useState(true)

    const getLiked = () => {
        api.get(`/api/getliked`, {
            params: {accountID: oc.accountID}
        }).then((response) => {
            if (response.data) setLiked(response.data)
            setLoading(false)
        }).catch((error) => {
            requestFailed(error)
            setLoading(false)
        })
    }

    useEffect(() => {
        getLiked()
    }, [location, oc.accountID])

    if (loading) return(<Loading/>)
    return (
        <div id="liked">
            <h2>Your likes</h2>
            <p id="resultcount">{liked ? (liked.length == 1 ? liked.length + " like" : liked.length + " likes") : ''}</p>
            <div id="postgrid">
            {liked && liked.map(({title, text, tags, url, likes}) => (
                    <PostCard key={url} title={title} text={text} tags={tags} url={"post/" + url}/>
                ))}
            </div>
            {locarr[1] != "profile" && <Outlet context={{oc: oc}}/>}
        </div>
    )
}

export default Liked;
